(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageDetailController', BannerImageDetailController);

    BannerImageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BannerImage', 'ImageStorage'];

    function BannerImageDetailController($scope, $rootScope, $stateParams, previousState, entity, BannerImage, ImageStorage) {
        var vm = this;

        vm.bannerImage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:bannerImageUpdate', function(event, result) {
            vm.bannerImage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
